import Api from '../api';
import { errorHandler } from '../common';
import { cleanObject } from '@/common/functions/cleanObject';
const queryString = require('query-string');
const { axios: api } = Api;

export const createMetaAccount = (payload) =>
	errorHandler(async () => {
		const data = await api.post('/meta/meta-account', payload);

		return { data: data.data };
	});

export const updateMetaAccount = (payload, accountId) =>
	errorHandler(async () => {
		const data = await api.patch(`/meta/meta-account/${accountId}`, payload);

		return { data: data.data };
	});

export const createAddAccount = (payload) =>
	errorHandler(async () => {
		const data = await api.post('/meta/add-account', payload);

		return { data: data.data };
	});

export const updateAddAccount = (payload, accountId) =>
	errorHandler(async () => {
		const data = await api.patch(`/meta/add-account/${accountId}`, payload);

		return { data: data.data };
	});

export const syncAddAccount = (payload) =>
	errorHandler(async () => {
		const data = await api.post(`/meta/sync-add-account`, payload);

		return { data: data.data };
	});

export const getMetaAccounts = () =>
	errorHandler(async () => {
		const data = await api.get('/meta/accounts');

		return { data: data.data };
	});

export const getMetaSpends = (payload) =>
	errorHandler(async () => {
		const data = await api.get(
			`/meta/spend/?` +
				queryString.stringify(cleanObject(payload), {
					arrayFormat: 'bracket',
				}),
		);

		return { data: data.data };
	});

export const addSpends = (payload) =>
	errorHandler(async () => {
		const data = await api.post('/meta/spend-csv', payload);

		return { data: data.data };
	});
